<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <div class="mb-3">
        <vs-input :label="$t('phone')" :placeholder="$t('please_enter_only_the_number_without_the_hyphen')" v-model="blacklistFormData.phone" class="w-full"/>
        <validation-error :model-error="blacklistFormErrors.phone"></validation-error>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/../eventbus'
import Blacklist from '@/models/Blacklist'

export default {
  name: 'Shared.Blacklist.Add',
  data () {
    return {
      blacklistFormData: {
        phone: ''
      },
      blacklistFormErrors: []
    }
  },
  mounted () {
    EventBus.$on('initBlacklistFormData', this.initBlacklistFormData)
    EventBus.$on('initAddBlacklist', this.addBlacklist)
  },
  methods: {
    initBlacklistFormData () {
      this.blacklistFormData = {
        phone: ''
      }
      this.blacklistFormErrors = {}
    },
    async addBlacklist () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addBlacklistButton', scale: 0.45})

      try {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)
          const response = await Blacklist.store(this.blacklistFormData)
          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })
          this.$store.dispatch('setIsFormInProgress', false)
          this.initBlacklistFormData()
          this.$emit('addBlacklistSuccess')
        }
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.blacklistFormErrors = errors.validationErrors
        this.$store.dispatch('setIsFormInProgress', false)
      }

      this.$vs.loading.close('#addBlacklistButton > .con-vs-loading')
    }
  }
}
</script>

<style lang="scss">
#addBlacklistButton {
  .con-vs-loading {
    position: absolute !important;
  }
}
</style>
